import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';

import { saveAs } from 'file-saver';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';

import { URL_SERVICIOS, URL_DOCS } from '../config/config';
import { ErrorsService } from './errors.service';
import { formatDate } from '@angular/common';
import { EncriptacionService } from './encriptacion.service';


@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    public http: HttpClient,
    public router: Router,
    private encriptacionService: EncriptacionService,
    public _errors: ErrorsService,
  ) { }




  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////       getDoctorList         /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Listado de doctores activos
  async getDoctorList(id_doctor = null, id_especialidad = null, zoom = null, hours_disp = null, cusId = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      doc_id: id_doctor,
      spe_id: id_especialidad,
      zoom: zoom,
      hours_disp: hours_disp,
      cus_id: cusId
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getDoctorList', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw 1;
    }
  }


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////       postListarBeneficiarios        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getSpecialityList(id_especialidad = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      spe_id: id_especialidad,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getSpecialityList ', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }


  async getCompleteSubSpecialityList() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getCompleteSubSpecialityList ', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  async postListInstitution() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListInstitution ', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }


  async postListTitle() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListTitle ', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////       postListarBeneficiarios        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async postListarBeneficiarios(use_rut) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      use_rut: use_rut,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarBeneficiarios', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw error;
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////       postListPlansXBeneficiaries        ////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async postListPlansXBeneficiaries(use_id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      use_id: use_id,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListPlansXBeneficiaries', JSON.stringify(params), httpOptions).toPromise()
      // console.log(data,'data-postListPlansXBeneficiaries');

      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw error;
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////       postListarAcompanantes        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async postListarAcompanantes(use_rut) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      use_rut: use_rut,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarAcompanantes', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw error;
    }
  }

  ///////////

  async postListarBeneficiarioMain(valor: string) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      text_busq: valor
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarBeneficiariosMain', JSON.stringify(params), httpOptions).toPromise()

      //console.log(data);

      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw error;

    }
  }



  async postListarBeneficiarioMyB(value: string) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      text_busq: value
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarBeneficiariosByM', JSON.stringify(params), httpOptions).toPromise()

      //console.log(data);

      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw error;

    }
  }

  async postListarusuariosSistema(value: string) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      text_busq: value
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarusuariosSistema', JSON.stringify(params), httpOptions).toPromise()

      //console.log(data);

      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw error;

    }
  }


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////       getDoctorInfo      /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getDoctorInfo(rut) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      rut: rut,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getDoctorInfo', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw 1;
    }
  }




  async postListCommuneProvinceRegion() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {}
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListCommuneProvinceRegion', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  async getListarConsultasChat() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getListarConsultasChat', JSON.stringify({}), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw 1;
    }
  }
  async postListarConsultasPorPagar(estado, doc_id, fecha_inicio, fecha_termino) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    var estado_value = null;
    var doc_value = null;

    if (estado != "") {
      estado_value = estado;
    } else {
      estado_value = null;
    }

    if (doc_id != "") {
      doc_value = doc_id;
    } else {
      doc_value = null;
    }


    let params = {
      estado: estado_value,
      doc_id: doc_value,
      fecha_inicio: fecha_inicio,
      fecha_termino: fecha_termino,
    }

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarConsultasPorPagar', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw 1;
    }
  }

  async getAppBooStatus() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getAppBooStatus', JSON.stringify({}), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error);
      throw 1;
    }
  }


  async postRealizaOnBoarding() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postRealizaOnBoarding', JSON.stringify({}), httpOptions).toPromise();
      return data
    }
    catch (error) {
      // this._errors.requestError(error);
      throw 1;
    }
  }



  async postSetPasswordDefault() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      // Aquí ajustamos la URL al endpoint del backend.
      let data = await this.http.post(URL_SERVICIOS + '/postSetPasswordDefault', JSON.stringify({}), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw 1;
    }
  }
  async postValidaDatosUsuario() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      // Aquí ajustamos la URL al endpoint del backend.
      let data = await this.http.post(URL_SERVICIOS + '/postValidaDatosUsuario', JSON.stringify({}), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw 1;
    }
  }

  async postNextHabilDay() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postNextHabilDay', JSON.stringify({}), httpOptions).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error);
      throw 1;
    }
  }

  async getInfoDomain() {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getInfoDomain', JSON.stringify({}), httpOptions).toPromise();
      let encriptado = this.encriptacionService.toBinary(JSON.stringify(data));
      sessionStorage.setItem('page', encriptado);
      return data;
    }
    catch (error) {
      // this._errors.requestError(error);
      throw 1;
    }
  }

  async getQuestions() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getQuestions', JSON.stringify({}), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      // this._errors.requestError(error);
      throw 1;
    }
  }



  getDevice() {
    let ua = navigator.userAgent;
    let dispositivo = {
      type: '',
      connection: (window.navigator['connection'] as any)?.effectiveType,
    };
    if (/iPhone|iPad|iPod/i.test(ua)) {
      dispositivo.type = 'IOS';
    }
    else if (/Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      dispositivo.type = 'Android';
    } else {
      dispositivo.type = 'Desktop';
    }

    return dispositivo;

  }



  getCodecs() {
    let codecs = {
      'audio': RTCRtpReceiver.getCapabilities('audio').codecs,
      'video': RTCRtpReceiver.getCapabilities('video').codecs,
    };
    return codecs;
  }

  verificarFecha(fecha_string) {
    let array_fecha = fecha_string.replaceAll(' ', '').replaceAll('-', '/').split('/');
    let fecha_date = new Date(array_fecha[2], array_fecha[1] - 1, array_fecha[0]);
    if (fecha_date.toString() == 'Invalid Date') {
      // //console.log('Fecha invalida-verificarFecha');
      return false;
    }
    let fecha_date_string = formatDate(fecha_date, 'yyyy-MM-dd', 'en-US');
    let array = fecha_date_string.split('-');
    if (parseInt(array_fecha[2]) == parseInt(array[0]) && parseInt(array_fecha[1]) == parseInt(array[1]) && parseInt(array_fecha[0]) == parseInt(array[2])) {
      return {
        fecha_date: fecha_date,
        fecha_date_string: fecha_date_string
      };
    } else {
      // //console.log('Fecha invalida-verificarFecha');
      return false;
    }
  }

  // Funcion para descargar documentos usando solo el att_id, se le agrega el parametro att_name, para cuando se van a buscar los archivos por el nombre de este
  async descargarFileAtt(att_id, name_file_desc, noDownload, use_id = null, att_use_id = null, boo_id = null, type_file = null, is_digital_pad = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
      responseType: 'blob' as 'blob'
    };
    let params = {
      att_id: att_id,
      use_id: use_id,
      att_use_id: att_use_id,
      boo_id: boo_id,
      type_file: type_file,
      is_digital_pad: is_digital_pad
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/descargarFileAtt', JSON.stringify(params), httpOptions).toPromise()
      if (!noDownload) {
        saveAs(data, name_file_desc);
        return name_file_desc;
      } else {
        //console.log(data);
        return data;
      }
    }
    catch (error) {
      // throw error;
      console.log(error)
      if (error.status = 404) {
        Swal.fire({
          icon: 'warning',
          // title: 'Favor reingresar',
          text: 'Archivo no encontrado',
          timer: 2000
        })
      }
    }
  }


  modalCargando() {
    Swal.fire({
      html: ` <div style="margin: 40px 0;">
                             <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                             <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Espere por favor...</h1>
                           </div>`,
      showConfirmButton: false,
      allowOutsideClick: false,
      timer: 1000000
    })
    Swal.showLoading();
  }

  modalExitoso(titulo, descripcion) {
    Swal.close();
    Swal.fire({
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br>' +
        ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >' + titulo + '</h1><br>' +
        ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" >' + descripcion + '</p><br>',
      // footer: '<button id="buttonInicio" style="border: 2px solid #316AD8;box-sizing: border-box;border-radius: 30px; width: 100%;height: 100%; background: #171994;font-family: Mulish;font-style: normal;font-weight: bold;font-size: 16px; line-height: 24px; align-items: center; text-align: center; color: #FFFFFF;" class="btn btn-outline-primary btn-lg" (click)="navegar()" >Volver al inicio</button> ',
      showCancelButton: false,
      showConfirmButton: false,
      timer: 4000
    })

  }

  modalError(titulo, descripcion) {
    Swal.close();
    Swal.fire({
      allowOutsideClick: true,
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>' +
        ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 24px; line-height: 26px; align-items: center; text-align: center; color: #171994;" >' + titulo + '</h1> <br>' +
        ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" >' + descripcion + '</p><br>',
      timer: 30000,
      showCancelButton: true,
      cancelButtonText: "Volver",
      showConfirmButton: false,
      customClass: {
        popup: 'swal2-custom-border',
        cancelButton: 'swal2-custom-cancel-btn'
      },
    })
  }

  verifyExtension(fileName, arrayType: String[]) {
    if (!fileName) {
      return false;
    }
    let arrayFileName = fileName.toLowerCase().split('.');
    for (let index = 0; index < arrayType.length; index++) {
      const element = arrayType[index];
      if (element == arrayFileName[arrayFileName.length - 1]) {
        return true;
      }
    }
    return false;
  }

  validaRut(rutCompleto) {
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto))
      return false;
    var tmp = rutCompleto.split('-');
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv == 'K') digv = 'K';
    return (this.dv(rut) == digv);
  }

  dv(T) {
    var M = 0, S = 1;
    for (; T; T = Math.floor(T / 10))
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
    return S ? S - 1 : 'K';
  }

  sleep(ms = 0) {
    return new Promise(r => setTimeout(r, ms));
  }

  validaEmail(email: string): boolean {
    try {
      const patronEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return patronEmail.test(email);
    } catch (error) {
      return false;
    }
  }

  async getInfoTips() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    let params = {
      'status': 123
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getInfoTips', params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      // this._errors.requestError(error);
      throw 1;
    }
  }
  async getInfoCampaigns() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getInfoCampaigns', JSON.stringify({}), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      // this._errors.requestError(error);
      throw 1;
    }
  }

  validaRutChileno(rut: string): boolean {
    if (!rut || rut.length < 8) return false;

    // Elimina puntos y guión
    const rutLimpio = rut.replace(/\./g, '').replace(/-/g, '');

    // Extrae dígito verificador
    const cuerpo = rutLimpio.slice(0, -1);
    let dv = rutLimpio.slice(-1).toUpperCase();

    // Valida que el cuerpo tenga sólo números
    if (!/^\d+$/.test(cuerpo)) return false;

    // Cálculo del dígito verificador
    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo.charAt(i)) * multiplo;
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    const dvEsperado = 11 - (suma % 11);
    let dvCalculado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();

    return dv === dvCalculado;
  }

  formateaRut(valor: string): string {
    // Elimina todo excepto números y K
    let rut = valor.replace(/[^0-9kK]/g, '').toUpperCase();

    if (rut.length <= 1) return rut;

    const cuerpo = rut.slice(0, -1);
    const dv = rut.slice(-1);

    // Agrega puntos cada 3 cifras desde la derecha hacia la izquierda
    const cuerpoFormateado = cuerpo
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g)
      ?.join('.')
      .split('')
      .reverse()
      .join('') || cuerpo;

    return `${cuerpoFormateado}-${dv}`;
  }


  async getColorList() {
    let httpOptions = {
      headers: new HttpHeaders({
        // 'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {};

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getColorList', JSON.stringify(params)).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }
 
 async postListarCodVerfificacion() {
  const httpOptions = {
    headers: new HttpHeaders({
      'authorization': sessionStorage.getItem('token') || '',
      'Content-Type': 'application/json'
    })
  };

  try {
    const response = await this.http.post(
      URL_SERVICIOS + '/postListarCodVerfificacion',
      JSON.stringify({}),
      httpOptions
    ).toPromise();

    return response;

  } catch (error) {
    this._errors.requestError(error);
    throw error;
  }
}

}
